import clsx from "clsx";

interface ILessonEntry {
  Classroom: string;
  Discipline: string;
  Discipline_Type: string;
  FIO_teacher: string;
  TimeIn: string;
  TimeOut: string;
  Day?: string;
}

export default function LessonEntry({
  Classroom,
  Discipline,
  Discipline_Type,
  FIO_teacher,
  TimeIn,
  TimeOut,
}: ILessonEntry) {
  const [hoursIn, minutesIn] = TimeIn.split(":");
  const [hoursOut, minutesOut] = TimeOut.split(":");
  const FTimeIn: string = hoursIn + ":" + minutesIn;
  const FTimeOut: string = hoursOut + ":" + minutesOut;
  let isLecture: boolean, isSeminar: boolean, isPractice: boolean;
  Discipline_Type === "Лек" ? (isLecture = true) : (isLecture = false);
  Discipline_Type === "Сем" ? (isSeminar = true) : (isSeminar = false);
  Discipline_Type === "Практ" ? (isPractice = true) : (isPractice = false);
  return (
    <div className="bg-white rounded shadow p-2 flex flex-col">
      <div className="bg-white flex gap-1 h-12 items-center">
        <div className="flex flex-col justify-between">
          <span>{FTimeIn}</span>
          <span>{FTimeOut}</span>
        </div>
        <div
          className={clsx(
            "h-full w-1 rounded-sm",
            { "bg-red-600": isPractice },
            { "bg-green-500": isLecture },
            { "bg-yellow-300": isSeminar }
          )}
        />
        <div className="flex flex-1 flex-col">
          <div className="flex flex-col justify-between">
            <span>{Discipline}</span>
            <span>{FIO_teacher}</span>
          </div>
        </div>
        <div className="flex flex-row justify-end">
          <span>{Classroom}</span>
        </div>
      </div>
    </div>
  );
}
